import { createMemo } from "solid-js";
import { getOrCreateBuffer } from "../../stores/streams.ts";
import { Sparkline } from "./Sparkline.tsx";

/**
 * Streams a single metric into the Sparkline by reading from the
 * per-metric ring buffer. The buffer is reactive: every push bumps a
 * version signal that triggers re-render.
 */
export function Waveform(props: { metric: string; color?: string }) {
  const buf = createMemo(() => getOrCreateBuffer(props.metric));
  const data = createMemo(() => {
    buf().version();
    const [, ys] = buf().series();
    return Array.from(ys);
  });
  return <Sparkline data={data} color={props.color} />;
}
